import { connect } from 'react-redux';

import { IApplicationState } from '@store';
import { AuthenticationStatus } from '@store/types';
import { logOut, setAccountId } from '@store/actions';

import Header, {
  IAccountPickerHeaderStateProps,
} from '../components/header/AccountPickerHeader';

interface IStateToProps
  extends Pick<IApplicationState, 'authentication' | 'accounts'> {}

const mapStateToProps = ({
  authentication,
  accounts,
}: IStateToProps): IAccountPickerHeaderStateProps => ({
  isAuthenticated: authentication.status === AuthenticationStatus.authenticated,
  accountId: authentication.user?.accountId,
  accounts: authentication.user?.adaptiveSuperUser ? accounts.accounts : [],
  adaptiveSuperUser: authentication.user?.adaptiveSuperUser || false,
});

const mapDispatchToProps = (dispatch: any) => ({
  selectAccountId: (accountId: string) => setAccountId(accountId),
  logOut: () => dispatch(logOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
